import { useLanguage } from "../i18n/LanguageContext";

const MEETING_IMAGE = "/assets/uba-office-director.jpg";

export const Process = () => {
  const { t } = useLanguage();

  return (
    <section id="proces" className="bg-[#f8fafc] py-20 lg:py-28" data-testid="process-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-2 lg:items-center lg:gap-20">
          <div>
            <p className="section-label" data-testid="process-label">{t.process.label}</p>
            <h2
              className="font-display mt-4 text-3xl font-bold tracking-tight text-[#0d2b52] sm:text-4xl"
              data-testid="process-title"
            >
              {t.process.title}
            </h2>

            <ol className="mt-12 space-y-0" data-testid="process-steps">
              {t.process.steps.map((step, i) => (
                <li key={i} className="relative flex gap-6 pb-10 last:pb-0" data-testid={`process-step-${i}`}>
                  {i < t.process.steps.length - 1 && (
                    <span className="absolute left-[19px] top-10 h-full w-px bg-[#cbd5e1]" aria-hidden="true" />
                  )}
                  <span className="font-display flex h-10 w-10 shrink-0 items-center justify-center bg-[#0d2b52] text-sm font-bold text-white">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div className="pt-1.5">
                    <h3 className="font-display text-lg font-bold text-[#0d2b52]">{step.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-[#475569]">{step.desc}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          <div className="flex items-center justify-center">
            <img
              src={MEETING_IMAGE}
              alt={t.process.title}
              className="max-h-[560px] w-full object-cover"
              data-testid="process-image"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
